import { items } from "./data"
import { FuelCard } from "./FuelCard"
import { StyledFuelListCard } from "./styled"
import { TCard } from "./types"

export const FuelListCard = () => {
  return (
    <StyledFuelListCard>
      {items.map((item:TCard, index: number) => {
        return (
          <FuelCard key={index} item={item} />
        )
      })}
    </StyledFuelListCard>
  )
}